import { render, staticRenderFns } from "./LibraryCard.vue?vue&type=template&id=30671a96&"
import script from "./LibraryCard.vue?vue&type=script&lang=js&"
export * from "./LibraryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports